import React from "react";
import enums from "helpers/enums";
import GeneralListPage from "@ui/ComponentUtils/GeneralListPage";
import { formatDateToRead } from "@ui/Utils/helper";

const columns = [
  {
    title: "Name",
    field: "name",
  },
  {
    title: "Method",
    field: "method",
  },
  {
    title: "Created Date",
    field: "dateCreated",
    render: (row) => formatDateToRead(row?.dateCreated),
  },
  {
    title: "Created By",
    render: (row) => row?.createdBy?.firstName + " " + row?.createdBy?.lastName,
  },
];

const PaymentMethodsList = () => {
  return (
    <GeneralListPage
      columns={columns}
      model={enums.models.paymentMethods}
      headerTitle="Payment Methods"
      searchFields={["name", "method"]}
      paginationMeta={{ pageSize: 10 }}
      hideAction={{ delete: true, selection: true, create: true }}
      onRowClick={false}
      options={{
        exportButton: {
          csv: true,
          pdf: true,
        },
      }}
    />
  );
};

export default PaymentMethodsList;
